var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight,"elevation":"2","rounded":""},on:{"click":_vm.turnCard}},[_c('canvas',{ref:"cardToLearn",attrs:{"cardId":_vm.cardId,"frontJson":_vm.frontJson}})])}
var staticRenderFns = []

export { render, staticRenderFns }